import * as React from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import dayjs from 'dayjs'
import _ from 'lodash'
import { HeaderSection } from '@lmc/ui-kit'
import { sizes } from '@lmc/common/constants'
import { useTranslation } from 'react-i18next'
import { LogCategory, LogCategoryItem } from '@lmc/ts-common'
import { getJSON } from '../../../common/services/api'
import CareDeliveryTable from './components/CareDeliveryTable/CareDeliveryTable'
import CareDeliveryFilters from './components/CareDeliveryFilters/CareDeliveryFilters'
import { Data } from './CareDeliveryScreen.types'

type CareDeliveryScreenProps = {
  categories: LogCategory[]
  items: LogCategoryItem[]
  preferredPeopleNominative: string
}

export function CareDeliveryScreen({
  categories,
  items,
  preferredPeopleNominative,
}: CareDeliveryScreenProps): React.ReactElement {
  const [to, setToDate] = React.useState(dayjs())
  const [from, setFromDate] = React.useState(dayjs().subtract(1, 'month'))
  const [isLoading, setIsLoading] = React.useState(true)
  const [data, setData] = React.useState<Data[] | null>(null)
  const [categoryId, setCategoryId] = React.useState<string | null>(null)
  const { t } = useTranslation()
  React.useEffect(() => {
    setIsLoading(true)
    const query = qs.stringify({
      from: from.format('DD-MM-YYYY'),
      to: to.format('DD-MM-YYYY'),
    })
    const url = categoryId
      ? `/api/aggregations/care-delivery/${categoryId}?${query}`
      : `/api/aggregations/care-delivery?${query}`

    getJSON({ url })
      .then((data) => {
        setData(data.result)
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }, [to, from, categoryId])

  // @ts-ignore
  if (!categories) return null

  return (
    <div style={styles.wrapper}>
      <HeaderSection title={t('reports.careDelivery.title')} />
      <CareDeliveryFilters
        categories={categories}
        to={to}
        from={from}
        setCategoryId={setCategoryId}
        setToDate={setToDate}
        setFromDate={setFromDate}
      />
      <CareDeliveryTable
        isLoading={isLoading}
        // @ts-ignore
        data={data}
        items={items}
        categories={categories}
        to={to}
        from={from}
        // @ts-ignore
        categoryId={categoryId}
        preferredPeopleNominative={preferredPeopleNominative}
      />
    </div>
  )
}

const styles = {
  wrapper: {
    maxWidth: sizes.fullWidthScreen,
    minHeight: 800,
    margin: '0 auto',
    padding: '24px',
  },
}

const mapStateToProps = (state: any) => ({
  categories: _.orderBy(state.data['log-categories'], 'name'),
  items: _.orderBy(state.data['log-category-items'], 'name'),
  preferredPeopleNominative:
    state.global?.home?.preferredPeopleNominative?.replace(/s$/, ''),
})

export default connect(mapStateToProps)(CareDeliveryScreen)
